export function skipLogicCore(): string {
  return 'skip-logic-core';
}

export interface SkipLogicQuestionSettings {
  id: string;
  page_id: number;
  element_id: number;
}

export interface SkipLogicQuestionConfig {
  id: string;
  page_id: number;
  element_id: number;
}

//
export const QUESTION_TYPE_CONFIG: Record<
  string,
  { label: string; operators: string[] }
> = {
  // Choice Types
  'single-choice': {
    label: 'Single Choice',
    operators: ['is', 'is_not', 'inc_any', 'ans'],
  },
  'multiple-choice': {
    label: 'Multiple Choice',
    operators: ['inc_any', 'inc_all', 'is_ex', 'ans'],
  },
  'drop-down-single-choice': {
    label: 'Drop Down Single Choice',
    operators: ['is', 'is_not', 'ans'],
  },
  'drop-down-multiple-choice': {
    label: 'Drop Down Multiple Choice',
    operators: ['inc_any', 'inc_all', 'is_ex', 'ans'],
  },

  // Text Types
  'open-ended': {
    label: 'Open Ended',
    operators: ['eq_text', 'cont', 'sw', 'ans'],
  },
  numeric: {
    label: 'Numeric',
    operators: ['eq_num', 'neq_num', 'gt', 'lt', 'bet_num', 'ans'],
  },

  // Media Types
  image: {
    label: 'Image',
    operators: ['ans', 'nans'],
  },
  video: {
    label: 'Video',
    operators: ['ans', 'nans'],
  },
  voice: {
    label: 'Voice',
    operators: ['ans', 'nans'],
  },
  file: {
    label: 'File',
    operators: ['ans', 'nans'],
  },

  // Matrix Types
  'single-grid': {
    label: 'Single Grid',
    operators: ['row_is', 'ans'],
  },
  'multiple-grid': {
    label: 'Multiple Grid',
    operators: ['row_is', 'ans'],
  },

  // Ordering
  'click-to-rank': {
    label: 'Click to Rank',
    operators: ['rank_is', 'ans'],
  },

  // Skip Logic (for reference)
  'skip-logic': {
    label: 'Skip Logic',
    operators: [],
  },
};
